import timezone from "moment-timezone";
export const appSettings = {
  AesKey: "8080808080808080",
  AesIv: "8080808080808080",
  agGridDDExceptionDefaulPageSize: 25,
  agGridDefaulPageSize: 25,
  agGridPageSizeSelector: [5, 10, 25, 50, 100, 500, 1000, 5000],
  timezone: timezone.tz.guess(),
  hideTriggerProfProdWFContextMenu: "docdistro_brighthousefinancials",
  excludedCategories: [
    "Configuration-RequesterAccount",
    "Configuration-RequesterEmailTemplate",
    "Configuration-RequesterFileLocations",
    "Configuration-BannerConfiguration",
    "SystemStatistics",
    "System-HeartBeatMonitoring",
    "Activity-RequestInformation",
  ],
  pendingMessagesCriticalCount: 100,
};
